module.exports = __webpack_public_path__ + "static/media/milestone.cfa90a9c.svg";